<template>
  <transition name="fade">
    <div class="ui-popver-wrapper" v-show="showPopup">
      <div class="ui-message-popup-content container">
        <div class="content-wrapper">
          <p class="message">{{ message }}</p>
        </div>
        <button class="btn" @click="handleClickConfirm">{{ confirmBtnText }}</button>
        <div class="icon icon-close" @click="handleClose"></div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"

export default {
  name: "loginByPhonePopup",
  methods: {
    ...mapMutations({
      closePopup: "loginByPhonePopup/closePopup"
    }),
    handleClickConfirm(e) {
      this.confirmCallback && this.confirmCallback(e)
    },
    handleClose() {
      this.closePopup()
    }
  },
  computed: {
    ...mapGetters({
      showPopup: "loginByPhonePopup/showPopup",
      message: "loginByPhonePopup/message",
      confirmBtnText: "loginByPhonePopup/confirmBtnText",
      confirmCallback: "loginByPhonePopup/confirmCallback"
    })
  }
}
</script>

<style lang="scss" scoped>
.ui-message-popup-content {
  width: 5.4rem;
  min-height: 4.46rem;
  max-height: 6rem;
  // overflow: auto;
  background: url("../../assets/images/pop_head.png") #ffffff no-repeat top center;
  background-size: 100% 1.35rem;
  padding-top: 1.3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .content-wrapper {
    width: 100%;
    min-height: 1.28rem;
    font-family: PingFang-SC-Medium;
    font-size: 0.34rem;
    color: #333333;
    text-align: center;
    padding: 0 0.3rem;
    line-height: 0.48rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon-close {
    width: 0.8rem;
    height: 0.8rem;
    position: absolute;
    bottom: -1.2rem;
    left: 50%;
    transform: translateX(-50%);
    background: url("../../assets/images/icon_delete@2x.png") no-repeat center;
    background-size: 80%;
  }
  .btn {
    margin-top: 0.2rem;
    height: 0.88rem;
    background: #f64e45;
    border-radius: 0.44rem;
    padding: 0 0.88rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFangSC-Regular;
    font-size: 0.32rem;
    color: #ffffff;
    line-height: 0.44rem;
    outline: none;
    border: none;
    &:active {
      opacity: 0.7;
    }
  }
}

.ui-popver-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  .container {
    border-radius: 0.2rem;
    // overflow: hidden;
    position: relative;
  }
}

.fade-enter,
.fade-leave-to {
  &.ui-popver-wrapper {
    background: rgab(0, 0, 0, 0);
  }
}

.fade-leave-to {
  &.ui-popver-wrapper {
    opacity: 0;
  }
}

.fade-enter-to {
  &.ui-popver-wrapper {
    background: rgab(0, 0, 0, 0.5);
  }
}

.fade-leave {
  &.ui-popver-wrapper {
    opacity: 1;
  }
}

.fade-enter-active {
  &.ui-popver-wrapper {
    transition: all 0.3s ease-in-out;
    .container {
      animation: scaleFade 0.3s ease-in-out;
    }
  }
}

.fade-leave-active {
  &.ui-popver-wrapper {
    transition: all 0.3s ease-in-out;
  }
}

@keyframes scaleFade {
  0% {
    transform: scale(0.95);
    opacity: 0.5;
  }
  45% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
